import { ViewerGroupRole } from '../types/launch-params';

export function canManageVkGroupApp(vkGroupViewerRole: ViewerGroupRole | null) {
  return vkGroupViewerRole === 'admin';
}
